export default {
  inspirations: 'Ispirazioni',
  gifts: 'Regali',
  occasions: 'Occasioni',
  'tutorials-and-advices': 'Tutorial e consigli',
  'home-furnishing': 'Arredo casa',
  highlights: 'Highlights',
}
